export default __webpack_public_path__ + "static/media/logo-app2e.ef151477.svg";